(function () {
  'use strict';

  var selector = '.wb-ing';

  function initIngredients(section) {
    if (!section || section.dataset.wbIngredientsReady === 'true') return;

    section.dataset.wbIngredientsReady = 'true';

    var track = section.querySelector('.wb-ing__track');
    var prevBtn = section.querySelector('.wb-ing__arrow--prev');
    var nextBtn = section.querySelector('.wb-ing__arrow--next');
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scrollBehavior = prefersReduced ? 'auto' : 'smooth';
    var rafId = null;

    if (!track) return;

    function getStep() {
      var card = track.querySelector('.wb-ing__card');

      if (!card) return track.clientWidth * 0.8;

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);

      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      if (!prevBtn || !nextBtn) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      var currentScroll = track.scrollLeft;

      prevBtn.disabled = currentScroll <= 4;
      nextBtn.disabled = maxScroll <= 4 || currentScroll >= maxScroll - 4;
    }

    function requestUpdate() {
      if (rafId) cancelAnimationFrame(rafId);

      rafId = requestAnimationFrame(function () {
        updateButtons();
        rafId = null;
      });
    }

    track.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        track.scrollBy({ left: -getStep(), behavior: scrollBehavior });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        track.scrollBy({ left: getStep(), behavior: scrollBehavior });
      });
    }

    updateButtons();

    section._wbIngredientsUpdate = requestUpdate;
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll(selector).forEach(initIngredients);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();